import clsx from 'clsx';

// Providers
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

// Components
import Icon from '@/components/base/Icon';
import { ActiveBar } from '@/components/composite/SelectedProfiles/ActiveBar';

// Types
import type { SelectedProfilesProps } from '@/components/composite/SelectedProfiles';

type MultiProfileItemProps = Required<SelectedProfilesProps> & {
    isActive: boolean;
};

export function MultiProfileItem({ isActive, itemsSize }: MultiProfileItemProps) {
    const { resetActiveSocialProfile } = useProfilesStore((state) => state);
    return (
        <div>
            <button
                disabled={isActive}
                onClick={resetActiveSocialProfile}
                className={clsx(
                    'relative flex h-9 w-9 items-center justify-center rounded-md border text-icoBlue focus:ring-0 focus:ring-offset-0',
                    {
                        'sm:h-11.5 sm:w-11.5': itemsSize === 'base',
                        'border-dashed border-icoBlue-200': !isActive,
                        'cursor-default border-icoBlue': isActive
                    }
                )}>
                <Icon icon="group" />
                <ActiveBar isActive={isActive} />
            </button>
        </div>
    );
}
